import * as t from "io-ts";
import { Address } from "./Address";

export const SelfEmployedDetails = t.intersection([
  t.type({
    business_name: t.string,
    type_of_business: t.string,
    months_self_employed: t.number,
  }),
  t.partial({
    self_employed_type: t.union([
      t.literal("full_time"),
      t.literal("part_time"),
    ]),
    business_address: Address,
  }),
]);

export interface SelfEmployedDetails {
  self_employed_type?: "full_time" | "part_time";
  business_name: string;
  type_of_business: string;
  months_self_employed: number;
  business_address?: Address;
}
